import { SessionsCard, TwoFactorCard } from '../../components/account-security.js';
import { PageHeader } from '../../components/ui.js';

/** Tenant self-service security: 2FA + active sessions (same as staff get). */
export function PortalSecurityPage() {
  return (
    <div>
      <PageHeader
        title="Security"
        description="Protect your account with two-factor authentication and manage your sessions."
      />
      <div className="space-y-6">
        <TwoFactorCard />
        <SessionsCard />
      </div>
    </div>
  );
}
